import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import Button from '@material-ui/core/Button'
import { makeStyles, Theme } from '@material-ui/core/styles'
import MenuIcon from '@material-ui/icons/Menu'
import clsx from 'clsx'
import React from 'react'

const appHeaderHeight = 60
const useStyles = makeStyles((theme: Theme) => ({
    fullHeight: {
        height: appHeaderHeight,
    },
    whiteFont: {
        color: theme.palette.common.white,
    },
    menuButton: {
        fontSize: pxToRem(16),
        fontWeight: 'normal',
        borderRadius: 0,
        padding: theme.spacing(0, 2),
    },
    iconButtonActive: {
        backgroundColor: `rgba(0,0,0,0.25)`,
        opacity: 1,

        '&:hover': {
            backgroundColor: `rgba(0,0,0,0.25)`,
        },
    },
}))

export interface NavBarMenuProps {
    onClick?: VoidFunction
    isActive?: boolean
}

const NavBarMenu: React.FC<NavBarMenuProps> = ({
    onClick,
    isActive = false,
}) => {
    const classes = useStyles()
    return (
        <Button
            data-testid="navBarMenuButton"
            className={clsx(
                classes.fullHeight,
                classes.whiteFont,
                classes.menuButton,
                isActive && classes.iconButtonActive
            )}
            onClick={onClick}
            startIcon={<MenuIcon fontSize="large" />}
        >
            Menu
        </Button>
    )
}

export default NavBarMenu
